<mat-toolbar class="dialog-toolbar">
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Escolher colunas da tabela</h1>
    <span class="spacer"></span>
    <button (click)="cancelar()" class="botao-header" matTooltip="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div mat-dialog-actions class="dialog-actions-top">
  <button mat-raised-button color="primary" (click)="gerarTabela()">
    <mat-icon>check</mat-icon> Inserir Tabela
  </button>
  <button color="acent" mat-raised-button (click)="cancelar()">Cancelar</button>
</div>

<mat-dialog-content class="dialog-content-scroll">
  <p>Arraste para reordenar. Desmarque para ocultar colunas.</p>

  <div cdkDropList (cdkDropListDropped)="drop($event)">
    <div *ngFor="let coluna of colunasSelecionadas; let i = index" cdkDrag class="coluna-item">
      <mat-checkbox [(ngModel)]="coluna.ativa">
        <span cdkDragHandle style="cursor: move;">☰</span>
        {{ coluna.nome }}
      </mat-checkbox>
    </div>
  </div>

  <!-- Seção de Subtabelas (só aparece se houver subtabelas disponíveis) -->
  <div *ngIf="subtabelasDisponiveis.length > 0" class="subtabelas-section">
    <mat-divider style="margin: 16px 0;"></mat-divider>
    <h3 class="subtabelas-titulo">Subtabelas disponíveis (detalhamento dos itens)</h3>
    <p class="subtabelas-descricao">Selecione quais subtabelas deseja incluir dentro de cada linha da tabela principal. Para cada subtabela ativa, arraste para reordenar e desmarque para ocultar colunas.</p>

    <div *ngFor="let subtabela of subtabelasDisponiveis" class="subtabela-container">
      <mat-checkbox [(ngModel)]="subtabela.ativa" class="subtabela-toggle">
        <strong>{{ subtabela.nome }}</strong>
      </mat-checkbox>

      <div *ngIf="subtabela.ativa" class="subtabela-colunas">
        <div cdkDropList (cdkDropListDropped)="dropSubtabelaColuna($event, subtabela)">
          <div *ngFor="let coluna of subtabela.colunas; let j = index" cdkDrag class="coluna-item subtabela-coluna-item">
            <mat-checkbox [(ngModel)]="coluna.ativa">
              <span cdkDragHandle style="cursor: move;">☰</span>
              {{ coluna.nome }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
